import getImage from "./GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import htmlToPdfmake from "html-to-pdfmake";
import moment from "moment";
import { getUser } from "../../../../Utils/CurrentUser";
import {
  calculateAgeParse,
  concatenateNames,
  getPatientsAllegies,
} from "../../../../Utils/Patient";
import {
  validateProcessECO,
  validateProcessEstres,
  validateProcessPrueba,
  validateProcessEKG,
  validateProcessHolter,
  validateProcessMapa,
} from "../../../../Utils/UtilOtherProcedures";

const eventoClinicoPDF = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  console.log("registro clinico", data);

  let body = [];
  let bodyDiagnostic = [];
  let bodyDiagnosticFromInterview = [];
  let bodyClinicNotes = [];
  let bodyTranscription = [];
  const fecha = moment(new Date()).format("DD-MM-YYYY h:mm");
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.names;
  const fechaAdmision = moment(data.infoAdmission.admision?.fecha).format(
    "YYYY-MM-DD"
  );

  let alergiesPatient = null;
  let listAlegies = "";
  if (data.hasOwnProperty("anamnesis")) {
    if (data.anamnesis !== undefined) {
      alergiesPatient = await getPatientsAllegies(data.anamnesis.id_historia);
      if (alergiesPatient !== null && alergiesPatient !== undefined) {
        listAlegies = alergiesPatient.reduce(
          (acc, current) => acc.concat(current.nombre + " - "),
          ""
        );
      }
    }
  }

  const supportDoc = data.medicoApoyo;

  let tableBodySignatures = [
    {
      // auto-sized columns have their widths based on their content
      unbreakable: true,
      layout: "headerLineOnly",
      border: [false, false, false, false],
      table: {
        widths: [125],
        headerRows: 1,
        alignment: "center",
        body: [
          [
            {
              image: await getImage(data.firmDoctor),
              fit: [100, 25],
              alignment: "center",
            },
          ],
          [
            {
              text:
                "Dr. " +
                data.professional.nombres +
                " " +
                data.professional.apellido1 +
                " " +
                data.professional.apellido2 +
                "\n" +
                data.professional.especialidad +
                "\n REG-" +
                data.professional.reg_medico,
              style: "medicStyle",
            },
          ],
        ],
      },
    },
  ];

  for (let j = 0; j < supportDoc.length; j++) {
    let supportDocInfo = supportDoc[j];
    let firmUrl = data.firmDoctorSupport[j];

    if (data.suportDoc !== null) {
      tableBodySignatures.push({
        unbreakable: true,
        layout: "headerLineOnly",
        border: [false, false, false, false],
        table: {
          widths: [125],
          headerRows: 1,
          alignment: "center",
          body: [
            [
              {
                image: await getImage(firmUrl),
                fit: [100, 25],
                alignment: "center",
              },
            ],
            [
              {
                text:
                  supportDocInfo.titulo +
                  " " +
                  supportDocInfo.nombres +
                  " " +
                  supportDocInfo.apellido1 +
                  "\n" +
                  supportDocInfo.especialidad +
                  "\nREG-" +
                  supportDocInfo.reg_medico,
                style: "medicStyle",
              },
            ],
          ],
        },
      });
    }
  }

  let signatures = [
    {
      unbreakable: true,
      margin: [10, 20, 50, 0],
      layout: {
        paddingTop: function (index, node) {
          applyVerticalAlignment(node, index, "bottom");
          return 0;
        },
        defaultBorder: false,
      },
      table: {
        widths: ["*", "*", "*"],
        headerRows: 1,
        body: [tableBodySignatures],
      },
    },
  ];

  let tableBodyOtherProcedures = [["", ""]];
  if (data.otherProcedures !== undefined && data.otherProcedures !== null) {
    let resultsPocedures = [];
    if (
      data.otherProcedures?.eco.hasOwnProperty("eco") ||
      data.otherProcedures?.estres.hasOwnProperty("estres") ||
      data.otherProcedures?.prueba.hasOwnProperty("prueba") ||
      data.otherProcedures?.ekg.hasOwnProperty("ekg") ||
      data.otherProcedures?.holter.hasOwnProperty("holter") ||
      data.otherProcedures?.mapa.hasOwnProperty("mapa")
    ) {
      console.log(
        "ECO",
        await validateProcessECO(data.otherProcedures?.eco.eco[0]),
        "estres",
        await validateProcessEstres(data.otherProcedures?.estres.estres[0]),
        "prueba",
        await validateProcessPrueba(data.otherProcedures?.prueba.prueba[0]),
        "ekg",
        await validateProcessEKG(data.otherProcedures?.ekg.ekg[0]),
        "holter",
        await validateProcessHolter(data.otherProcedures?.holter.holter[0]),
        "mapa",
        await validateProcessMapa(data.otherProcedures?.mapa.mapa[0])
      );
      let resultOtherProcedureEco = (await validateProcessECO(
        data.otherProcedures?.eco.eco[0]
      ))
        ? data.otherProcedures?.eco.eco[0].conclusiones
        : null;
      let resultOtherProcedureEstres = (await validateProcessEstres(
        data.otherProcedures?.estres.estres[0]
      ))
        ? data.otherProcedures?.estres.estres[0].conclusiones
        : null;
      let resultOtherProcedurePrueba = (await validateProcessPrueba(
        data.otherProcedures?.prueba.prueba[0]
      ))
        ? data.otherProcedures?.prueba.prueba[0].conclusiones
        : null;
      let resultOtherProcedureEkg = (await validateProcessEKG(
        data.otherProcedures?.ekg.ekg[0]
      ))
        ? data.otherProcedures?.ekg.ekg[0].conclusions !== undefined &&
          data.otherProcedures?.ekg.ekg[0].conclusions !== null
          ? data.otherProcedures?.ekg.ekg[0].conclusions
          : data.otherProcedures?.ekg.ekg[0].conclusion !== undefined &&
            data.otherProcedures?.ekg.ekg[0].conclusion !== null
          ? data.otherProcedures?.ekg.ekg[0].conclusion
          : null
        : null;
      let resultOtherProcedureHolter = (await validateProcessHolter(
        data.otherProcedures?.holter.holter[0]
      ))
        ? data.otherProcedures?.holter.holter[0].conclusion
        : null;
      let resultOtherProcedureMapa = (await validateProcessMapa(
        data.otherProcedures?.mapa.mapa[0]
      ))
        ? data.otherProcedures?.mapa.mapa[0].conclusion
        : null;

      if (resultOtherProcedureEco !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "1"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEco,
          });
        }
      }
      if (resultOtherProcedureEstres !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "3"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEstres,
          });
        }
      }
      if (resultOtherProcedurePrueba !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "4"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedurePrueba,
          });
        }
      }
      if (resultOtherProcedureEkg !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "2"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEkg,
          });
        }
      }
      if (resultOtherProcedureHolter !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "6"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureHolter,
          });
        }
      }
      if (resultOtherProcedureMapa !== null) {
        let nameServ = data?.cita.servicio.servicios.filter(
          (serv) => serv.formato === "7"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureMapa,
          });
        }
      }

      console.log("MASDE1PROCEDIMIENTO", resultsPocedures);
      console.log(
        "TIPO",
        typeof resultsPocedures,
        "CONT",
        resultsPocedures,
        "json",
        JSON.stringify(resultsPocedures)
      );
    }
    console.log("WDO", resultsPocedures);
    if (JSON.stringify(resultsPocedures) !== "[]") {
      try {
        for (let k = 0; k < resultsPocedures.length; k++) {
          tableBodyOtherProcedures.push(
            [{ text: "Procedimiento: ", style: "tableheader" }, ""],
            [
              {
                text:
                  resultsPocedures[k].code_cups +
                  " " +
                  resultsPocedures[k].service_name,
                bold: true,
                alignment: "left",
                colSpan: 2,
                style: "textStyle",
              },
              "",
            ],
            [
              {
                text: resultsPocedures[k].result_procedure,
                style: "textStyle",
                colSpan: 2,
              },
              "",
            ]
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\n Nit:" +
              data.profile.nit +
              "\n" +
              data.profile.direccion.direccion +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2 +
              " \n Fecha de Atención: " +
              data.day,
            style: "head",
          },
        ],
      ],
    },
  };

  if (typeof data.ordenes !== "undefined") {
    body[0] = [
      { text: "CUPS ", style: "textStyle", bold: true },
      { text: "Descripción", style: "textStyle", bold: true },
      { text: "Cantidad", style: "textStyle", bold: true },
      { text: "Observaciones", style: "textStyle", bold: true },
    ];

    for (
      let i = 0;
      i < data.ordenes.ordenes.ordenes.addedDiagnostics.length;
      i++
    ) {
      body[i + 1] = [
        {
          text: data.ordenes.ordenes.ordenes.addedDiagnostics[i].cupscod,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.ordenes.ordenes.addedDiagnostics[i].cupsnom,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.ordenes.ordenes.hasOwnProperty("addedDiagnostics")
            ? data.ordenes.ordenes.ordenes.amount[i]
            : "",
          style: "tableTexStyle",
        },
        {
          text: data.ordenes.ordenes.ordenes.hasOwnProperty("addedDiagnostics")
            ? data.ordenes.ordenes.ordenes.amount[i]
            : "",
          style: "tableTexStyle",
        },
      ];
    }
  }

  if (typeof data.diagnostico !== "undefined") {
    bodyDiagnostic.push(
      [{ text: "Diagnóstico", style: "tableheader", colSpan: 2 }, "", "", ""],
      [
        { text: "Codigo CIE-10 ", style: "textStyle", bold: true },
        { text: "Nombre", style: "textStyle", bold: true },
        { text: "Tipo", style: "textStyle", bold: true },
        { text: "Observación", style: "textStyle", bold: true },
      ]
    );

    for (let i = 0; i < data.diagnostico.diagnostico.diagnostico.length; i++) {
      bodyDiagnostic.push([
        {
          text: data.diagnostico.diagnostico.diagnostico[i].codigo,
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.diagnostico.diagnostico[i].nombre,
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.diagnostico.diagnostico[i].hasOwnProperty(
            "tipo"
          )
            ? data.diagnostico.diagnostico.diagnostico[i].tipo
            : "",
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.diagnostico.diagnostico[i].hasOwnProperty(
            "observacion"
          )
            ? data.diagnostico.diagnostico.diagnostico[i].observacion
            : "",
          style: "tableTexStyle",
        },
      ]);
    }
  }

  if (data.medicalRegister !== undefined && data.medicalRegister !== null) {
    if (
      data.medicalRegister.cie10_diagnostico !== undefined &&
      data.medicalRegister.cie10_diagnostico !== null
    ) {
      bodyDiagnosticFromInterview.push(
        [{ text: "Diagnóstico", style: "tableheader", colSpan: 2 }, "", ""],
        [
          { text: "Codigo CIE-10 ", style: "textStyle", bold: true },
          { text: "Nombre", style: "textStyle", bold: true },
          "",
        ]
      );

      for (
        let i = 0;
        i < data.medicalRegister.cie10_diagnostico.cie10_diagnostico.length;
        i++
      ) {
        bodyDiagnosticFromInterview.push([
          {
            text: data.medicalRegister.cie10_diagnostico.cie10_diagnostico[i]
              .codigo,
            style: "tableTexStyle",
          },
          {
            text: data.medicalRegister.cie10_diagnostico.cie10_diagnostico[i]
              .nombre,
            style: "tableTexStyle",
          },
          "",
        ]);
      }
    }
  }

  if (
    typeof data.notas_clinicas != "undefined" &&
    data.notas_clinicas != null
  ) {
    let notas = data.notas_clinicas.filter(
      (nota) => nota.tipo_nota === "N"
    );
    bodyClinicNotes.push(
      [{ text: "Notas Médicas", style: "tableheader" }, "", "", ""],
      [
        { text: "Fecha", bold: true, fontSize: 10 },
        { text: "Usuario", bold: true, fontSize: 10 },
        { text: "Nota", bold: true, fontSize: 10 },
        { text: "Profesional", bold: true, fontSize: 10 },
      ]
    );

    try {
      for (let j = 0; j < notas.length; j++) {
        let url_doctor_nota_evolucion =
          process.env.REACT_APP_PUBLIC_URL +
          notas[j].firma_doctor +
          "/" +
          sessionStorage.getItem("token");
        const element = notas[j];
        const userInfo = await getUser(element.id_usuario);
        console.log("usuarioPDF", userInfo);
        bodyClinicNotes.push([
          {
            text: moment(element.fecha).format("YYYY-MM-DD"),
            style: "textStyle",
          },
          {
            text: concatenateNames(
              userInfo.nombres,
              userInfo.apellido1,
              userInfo.apellido2
            ),
            style: "textStyle",
          },
          { text: element.nota_clinica, style: "textStyle" },
          {
            unbreakable: true,
            layout: "headerLineOnly",
            border: [false, false, false, false],
            table: {
              widths: [80],
              headerRows: 1,
              alignment: "left",
              body: [
                [
                  {
                    image: await getImage(url_doctor_nota_evolucion),
                    fit: [80, 50],
                    alignment: "left",
                  },
                ],
                [
                  {
                    text:
                      element.nombres +
                      " " +
                      element.apellido1 +
                      " " +
                      element.apellido2 +
                      "\n" +
                      (element.especialidad ?? element.nombre_cargo) +
                      (element.reg_medico
                        ? `\n REG- ${element.reg_medico}`
                        : ""),

                    style: "medicNote",
                  },
                ],
              ],
            },
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
    //}
  }

  if (data.transcripcion !== null) {
    bodyTranscription.push(
      [
        {
          text: data.cupsProcedure + " " + data.nameProcedure,
          style: "tableheader",
          colSpan: 2,
        },
        "",
      ],
      [
        {
          text: data.transcripcion?.transcripcion,
          style: "textStyle",
          colSpan: 2,
        },
        "",
      ]
    );
  }

  let tableBodyMedicine = [];

  if (
    typeof data.ordenes !==
    "undefined" /* && data.ordenes.tratamiento.tratamiento !== null && data.ordenes.tratamiento.tratamiento !== undefined && data.ordenes.tratamiento.tratamiento >0 */
  ) {
    tableBodyMedicine.push(
      [
        { text: "Medicamentos", style: "tableheader", colSpan: 2 },
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
      [
        { text: "Principio", bold: true, fontSize: 9 },
        { text: "Concentración", bold: true, fontSize: 9 },
        { text: "Forma Farmacéutica", bold: true, fontSize: 9 },
        { text: "Vía", bold: true, fontSize: 9 },
        { text: "Dosis", bold: true, fontSize: 9 },
        { text: "Frecuencia", bold: true, fontSize: 9 },
        { text: "Duración", bold: true, fontSize: 9 },
        { text: "Unidades", bold: true, fontSize: 9 },
      ]
    );

    try {
      for (let k = 0; k < data.ordenes.tratamiento.tratamiento.length; k++) {
        tableBodyMedicine.push([
          {
            text: data.ordenes.tratamiento.tratamiento[k].principio_activo,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].concentracion,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].forma_farmaceutica,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].via_administracion,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].dosis,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].frecuencia,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].duracion,
            style: "tableTexStyle",
          },
          {
            text: data.ordenes.tratamiento.tratamiento[k].unidades_requeridas,
            style: "tableTexStyle",
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  /*  let urlServe =
    process.env.REACT_APP_PUBLIC_URL +
    "profesional/ver-firma/" +
    data.id_profesional +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma = "";
  //let urlServe = process.env.REACT_APP_PUBLIC_URL+  'profesional/ver-firma/11/' +   sessionStorage.getItem('token');
  //console.log(urlFirma);
  let test = fetch(urlServe).then((response) => {
    if (response.status === 500) {
      return false;
    } else {
      return true;
    }
  }); */

  /*  let isImg = await test;

  if (isImg) {
    urlFirma = urlServe;
  } else {
    urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }
 */
  let htmlSpeechTerapy = null;
  if (data.speechTerapy !== null && data.speechTerapy !== undefined) {
    if (data.speechTerapy.hasOwnProperty("fonoaudiologia")) {
      console.log("test");
      htmlSpeechTerapy = htmlToPdfmake(data.speechTerapy.fonoaudiologia);
      console.log("htmlRender", htmlSpeechTerapy, { tableAutoSize: true });
    } else {
      htmlSpeechTerapy = null;
    }
  }

  const ananmnesisInformation = () => {
    if (typeof data.anamnesis !== "undefined") {
      return {
        margin: [0, 0, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          widths: ["*"],
          headerRows: 1,
          body: [
            [
              {
                text: "Anamnesis ",
                style: "tableheader",
                border: [false, false, false, true],
              },
            ],
            [{ text: "Motivo de Consulta  ", bold: true, style: "textStyle" }],
            [
              {
                text:
                  data.anamnesis.motivo_consulta !== null
                    ? data.anamnesis.motivo_consulta
                    : "",
                style: "textStyle",
              },
            ],
            [{ text: "Enfermedad Actual  ", bold: true, style: "textStyle" }],
            [
              {
                text:
                  data.anamnesis.enfermedad_actual !== null
                    ? data.anamnesis.enfermedad_actual
                    : "",
                style: "textStyle",
              },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const backgroundInformation = () => {
    if (typeof data.antecedentes !== "undefined") {
      let tableInmuzations =
        data.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.hasOwnProperty(
          "table"
        )
          ? data.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones
              .table
          : [];
      let listInmunizations = tableInmuzations.reduce(
        (acc, cur, idx) =>
          tableInmuzations.length === idx + 1
            ? acc + cur.vacuna + " Fecha: " + cur.fecha
            : acc + cur.vacuna + " Fecha: " + cur.fecha + " | ",
        ""
      );
      let tablePharmacological =
        data.antecedentes.farmacologicos.farmacologicos[0].farmacologico.hasOwnProperty(
          "table"
        )
          ? data.antecedentes.farmacologicos.farmacologicos[0].farmacologico
              .table
          : [];
      let listPharmacological = tablePharmacological.reduce(
        (acc, cur, idx) =>
          tablePharmacological.length === idx + 1
            ? acc + cur.principioactivo + " " + cur.concentracion
            : acc + cur.principioactivo + " " + cur.concentracion + " | ",
        ""
      );
      return {
        margin: [0, 0, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: [150, 50, "*"],
          body: [
            [
              {
                text: "Antecedentes personales ",
                style: "tableheader",
                border: [false, false, false, true],
                colSpan: 3,
              },
              "",
              "",
            ],
            [{ text: "Patológicos: ", bold: true, fontSize: 10 }, "", ""],
            [
              { text: "HIPERTENSIÓN -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "hipertension"
                )
                  ? data.antecedentes.patologicos.patologicos[0].hipertension
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "hipertension"
                )
                  ? data.antecedentes.patologicos.patologicos[0].hipertension
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "METÁBOLICOS -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "metabolicos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].metabolicos
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "metabolicos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].metabolicos
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "CARDIACOS -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "cardiacos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].cardiacos.value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "cardiacos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].cardiacos
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "INFECCIOSOS", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "infecciosos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].infecciosos
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "infecciosos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].infecciosos
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "VASCULARES -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "vasculares"
                )
                  ? data.antecedentes.patologicos.patologicos[0].vasculares
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "vasculares"
                )
                  ? data.antecedentes.patologicos.patologicos[0].vasculares
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "ALÉRGICOS -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "alergicos"
                )
                  ? data.antecedentes.patologicos.patologicos[0].alergicos.value
                  : "No",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                    "alergicos"
                  ) &&
                  alergiesPatient !== null &&
                  alergiesPatient !== undefined
                    ? listAlegies
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "CANCER -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "cancer"
                )
                  ? data.antecedentes.patologicos.patologicos[0].cancer.value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "cancer"
                )
                  ? data.antecedentes.patologicos.patologicos[0].cancer
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "TRANSFUSIONES -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "transfusiones"
                )
                  ? data.antecedentes.patologicos.patologicos[0].transfusiones
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "transfusiones"
                )
                  ? data.antecedentes.patologicos.patologicos[0].transfusiones
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "AUTOINMUNES -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "autoinmunes"
                )
                  ? data.antecedentes.patologicos.patologicos[0].autoinmunes
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "autoinmunes"
                )
                  ? data.antecedentes.patologicos.patologicos[0].autoinmunes
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "TRAUMÁTICO -", style: "textStyle" },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "traumatico"
                )
                  ? data.antecedentes.patologicos.patologicos[0].traumatico
                      .value
                  : "No",
                style: "textStyle",
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "traumatico"
                )
                  ? data.antecedentes.patologicos.patologicos[0].transfusiones
                      .comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACIONES -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: data.antecedentes.patologicos.patologicos[0].hasOwnProperty(
                  "observation"
                )
                  ? data.antecedentes.patologicos.patologicos[0].observation
                  : "No",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            ["", "", ""],
            [
              { text: "Quirúrgicos: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.quirurgicos.quirurgicos[0].quirurgico
                    .value !== null
                    ? data.antecedentes.quirurgicos.quirurgicos[0].quirurgico
                        .value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.quirurgicos.quirurgicos[0].quirurgico
                    .comentario !== ""
                    ? data.antecedentes.quirurgicos.quirurgicos[0].quirurgico
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACIÓN -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.quirurgicos.quirurgicos[0].observation
                  ? data.antecedentes.quirurgicos.quirurgicos[0].observation
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            [
              { text: "Farmacológicos: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.farmacologicos.farmacologicos[0]
                    .farmacologico.value !== null
                    ? data.antecedentes.farmacologicos.farmacologicos[0]
                        .farmacologico.value
                    : "",
                style: "textStyle",
              },
              {
                text: listPharmacological,
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACIÓN -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.farmacologicos.farmacologicos[0]
                  .observation
                  ? data.antecedentes.farmacologicos.farmacologicos[0]
                      .observation
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            [
              { text: "Inmunizaciones: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.inmunizaciones.inmunizaciones[0]
                    .inmunizaciones.value !== null
                    ? data.antecedentes.inmunizaciones.inmunizaciones[0]
                        .inmunizaciones.value
                    : "",
                style: "textStyle",
              },
              {
                text: listInmunizations,
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACIÓN -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.inmunizaciones.inmunizaciones[0]
                  .observation
                  ? data.antecedentes.inmunizaciones.inmunizaciones[0]
                      .observation
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            ["", "", ""],
            [{ text: "Familiares: ", bold: true, fontSize: 10 }, "", ""],
            [
              { text: "CANCER -", style: "textStyle" },
              {
                text:
                  data.antecedentes.familiares.familiares[0].cancer.value !==
                  null
                    ? data.antecedentes.familiares.familiares[0].cancer.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.familiares.familiares[0].cancer
                    .comentario !== ""
                    ? data.antecedentes.familiares.familiares[0].cancer
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "DIABETES -", style: "textStyle" },
              {
                text:
                  data.antecedentes.familiares.familiares[0].diabetes.value !==
                  null
                    ? data.antecedentes.familiares.familiares[0].diabetes.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.familiares.familiares[0].diabetes
                    .comentario !== ""
                    ? data.antecedentes.familiares.familiares[0].diabetes
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "ENFERMEDAD CORONARIA -", style: "textStyle" },
              {
                text:
                  data.antecedentes.familiares.familiares[0].enf_coronaria
                    .value !== null
                    ? data.antecedentes.familiares.familiares[0].enf_coronaria
                        .value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.familiares.familiares[0].enf_coronaria
                    .comentario !== ""
                    ? data.antecedentes.familiares.familiares[0].enf_coronaria
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "HIPERTENSIÓN -", style: "textStyle" },
              {
                text:
                  data.antecedentes.familiares.familiares[0].hipertension
                    .value !== null
                    ? data.antecedentes.familiares.familiares[0].hipertension
                        .value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.familiares.familiares[0].hipertension
                    .comentario !== ""
                    ? data.antecedentes.familiares.familiares[0].hipertension
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "MUERTE SUBITA -", style: "textStyle" },
              {
                text:
                  data.antecedentes.familiares.familiares[0].muerte_subita
                    .value !== null
                    ? data.antecedentes.familiares.familiares[0].muerte_subita
                        .value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.familiares.familiares[0].muerte_subita
                    .comentario !== ""
                    ? data.antecedentes.familiares.familiares[0].muerte_subita
                        .comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "OBSERVACIÓN -", style: "textStyle" },
              {
                text: !!data.antecedentes.familiares.familiares[0].observation
                  ? data.antecedentes.familiares.familiares[0].observation
                  : "",
                style: "textStyle",
                colSpan: 2,
              },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const backgroundInformationHabits = () => {
    if (typeof data.antecedentes !== "undefined") {
      let subtances = [];
      let sustancias = [
        "cocaina",
        "bazuco",
        "extasis",
        "heroina",
        "lcd",
        "hongos",
        "marihuana",
        "ghb",
      ];
      if (data.antecedentes.habitos.habitos[0].cocaina === "Si") {
        subtances.push("Cocaina");
      } else if (data.antecedentes.habitos.habitos[0].bazuco === "Si") {
        subtances.push("Bazuco");
      } else if (data.antecedentes.habitos.habitos[0].extasis === "Si") {
        subtances.push("Extasis");
      } else if (data.antecedentes.habitos.habitos[0].heroina === "Si") {
        subtances.push("Heroina");
      } else if (data.antecedentes.habitos.habitos[0].lcd === "Si") {
        subtances.push("LCD");
      } else if (data.antecedentes.habitos.habitos[0].hongos === "Si") {
        subtances.push("Hongos");
      } else if (data.antecedentes.habitos.habitos[0].marihuana === "Si") {
        subtances.push("Marihuana");
      } else if (data.antecedentes.habitos.habitos[0].ghb === "Si") {
        subtances.push("GHB");
      }
      let riesgoFumador = "";
      let ipa = "";
      if (data.antecedentes.habitos.habitos[0].paquetes_anio < 20) {
        ipa = data.antecedentes.habitos.habitos[0].paquetes_anio.toString();
        riesgoFumador = ipa + " IPA - Riesgo leve";
      } else if (
        data.antecedentes.habitos.habitos[0].paquetes_anio > 19 &&
        data.antecedentes.habitos.habitos[0].paquetes_anio < 40
      ) {
        ipa = data.antecedentes.habitos.habitos[0].paquetes_anio.toString();
        riesgoFumador = ipa + " IPA - Riesgo moderado";
      } else {
        ipa = data.antecedentes.habitos.habitos[0].paquetes_anio.toString();
        riesgoFumador = ipa + " IPA Riesgo alto";
      }
      return {
        unbreakable: true,
        margin: [0, 0, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*"],
          body: [
            [
              {
                text: "Antecedentes Hábitos",
                style: "tableheader",
                colSpan: 4,
                border: [false, false, false, true],
              },
              "",
              "",
              "",
            ],
            [
              { text: "Fumador: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habitos.habitos[0].fumador === ""
                    ? "No"
                    : data.antecedentes.habitos.habitos[0].fumador,
                style: "textStyle",
              },
              {
                text: "Índice de cigarrillos por año: ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habitos.habitos[0].paquetes_anio === ""
                    ? ""
                    : riesgoFumador,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Exposición Humo de Leña : ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habitos.habitos[0].humo_lena === ""
                    ? "No"
                    : data.antecedentes.habitos.habitos[0].humo_lena,
                style: "textStyle",
              },
              { text: "Años de Exposición: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habitos.habitos[0].tiempo_anios === ""
                    ? "Ninguno"
                    : data.antecedentes.habitos.habitos[0].tiempo_anios,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Sustancias Psicoactivas: ",
                style: "textStyle",
                bold: true,
              },
              {
                text: data.antecedentes.habitos.habitos[0].sustancia_psico,
                style: "textStyle",
              },
              { text: "Sustancias: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habitos.habitos[0].sustancia_psico === "No"
                    ? data.antecedentes.habitos.habitos[0].sustancia_psico
                    : subtances.toString(),
                style: "textStyle",
              },
            ],
            [
              { text: "Consumo de Alcohol: ", style: "textStyle", bold: true },
              {
                text: data.antecedentes.habitos.habitos[0].alcohol,
                style: "textStyle",
              },
              {
                text: "Consumo de Alcohol en el último año:",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habitos.habitos[0].alcohol === "Si"
                    ? " Frec." +
                      data.antecedentes.habitos.habitos[0].alcohol_frecuencia
                    : "No",
                style: "textStyle",
              },
            ],
            [
              { text: "Actividad Fisica: ", style: "textStyle", bold: true },
              {
                text: data.antecedentes.habitos.habitos[0].actividad_fisica,
                style: "textStyle",
              },
              {
                text: "Actividades/Frecuencia: ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habitos.habitos[0].actividades_cuales
                    .length !== 0
                    ? data.antecedentes.habitos.habitos[0].actividades_cuales.toString()
                    : "",
                style: "textStyle",
              },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const systemInformation = () => {
    try {
      if (data.sistemas != null && data.sistemas != undefined) {
        return {
          unbreakable: true,
          margin: [0, 0, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Revisión por sistema",
                  style: "tableheader",
                  colSpan: 2,
                  border: [false, false, false, true],
                },
                "",
              ],
              [
                { text: "Síntomas Generales: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.sintomas_generales, style: "textStyle" },
              ],
              [
                { text: "Respiratorios: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.respiratorio, style: "textStyle" },
              ],
              [
                { text: "Cardiovascular: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.cardiovascular, style: "textStyle" },
              ],
              [
                { text: "Gastrointestinal: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.gastrointestinal, style: "textStyle" },
              ],
              [
                { text: "Genitourinario: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.genitourinario, style: "textStyle" },
              ],
              [
                { text: "Osteomuscular: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.osteomuscular, style: "textStyle" },
              ],
              [
                { text: "Dermatológico: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.dermatologico, style: "textStyle" },
              ],
              [
                { text: "Endocrino: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.endocrino, style: "textStyle" },
              ],
              [
                { text: "Neurológico: ", bold: true, fontSize: 10 },
                { text: data.sistemas?.neurologico, style: "textStyle" },
              ],
            ],
          },
        };
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  let presionArterial2 =
    data.fisico?.presion_arterial2 !== null
      ? "/" + data.fisico?.presion_arterial2
      : "";

  const physicalInformations = () => {
    try {
      if (data.fisico != null && data.fisico != undefined) {
        return {
          unbreakable: true,
          margin: [0, 0, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*", "auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Examen Físico ",
                  style: "tableheader",
                  border: [false, false, false, true],
                  colSpan: 4,
                },
                "",
                "",
                "",
              ],
              [
                { text: "Género: ", style: "textStyle", bold: true },
                { text: data.gender, style: "textStyle" },
                {
                  text: "Frecuencia Cardíaca:",
                  style: "textStyle",
                  bold: true,
                },
                {
                  text: data.fisico.frecuencia_cardiaca + " (lpm)",
                  style: "textStyle",
                },
              ],
              [
                { text: "Peso: ", style: "textStyle", bold: true },
                { text: data.fisico.peso + " (kg)", style: "textStyle" },
                {
                  text: "Frecuencia Respiratoria:",
                  style: "textStyle",
                  bold: true,
                },
                {
                  text: data.fisico.frecuencia_respiratoria + " (resp/min)",
                  style: "textStyle",
                },
              ],
              [
                { text: "Talla: ", style: "textStyle", bold: true },
                { text: data.fisico.talla + "(cm)", style: "textStyle" },
                { text: "Presión Arterial:", style: "textStyle", bold: true },
                {
                  text:
                    data.fisico.presion_arterial + presionArterial2 + " (mmHg)",
                  style: "textStyle",
                },
              ],
              [
                {
                  text: "Superficie Corporal:",
                  style: "textStyle",
                  bold: true,
                },
                {
                  text: data.fisico.superficie_corporal + " (mc)",
                  style: "textStyle",
                },
                {
                  text: "Índice de Masa Corporal:",
                  style: "textStyle",
                  bold: true,
                },
                { text: data.fisico.masa_corporal, style: "textStyle" },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const physicalInformationBody = () => {
    try {
      if (data.fisico != null && data.fisico != undefined) {
        return {
          margin: [0, 5, 0, 10],
          pageOrientation: "portrait",
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Aspecto General: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, true, false, false],
                },
                {
                  text: data.fisico.aspecto_general,
                  style: "textStyle",
                  border: [false, true, false, false],
                },
              ],
              [
                { text: "Cabeza y Cara: ", bold: true, fontSize: 10 },
                { text: data.fisico.cabeza_cara, style: "textStyle" },
              ],
              [
                { text: "Otorrino: ", bold: true, fontSize: 10 },
                { text: data.fisico.otorrino, style: "textStyle" },
              ],
              [
                { text: "Ojos: ", bold: true, fontSize: 10 },
                { text: data.fisico.ojos, style: "textStyle" },
              ],
              [
                { text: "Cuello: ", bold: true, fontSize: 10 },
                { text: data.fisico.cuello, style: "textStyle" },
              ],
              [
                { text: "Torax: ", bold: true, fontSize: 10 },
                { text: data.fisico.torax, style: "textStyle" },
              ],
              [
                { text: "Cardiovascular ", bold: true, fontSize: 10 },
                { text: data.fisico.cardiovascular, style: "textStyle" },
              ],
              [
                { text: "Pulmonar ", bold: true, fontSize: 10 },
                { text: data.fisico.pulmonar, style: "textStyle" },
              ],
              [
                { text: "Abdomen ", bold: true, fontSize: 10 },
                { text: data.fisico.abdomen, style: "textStyle" },
              ],
              [
                { text: "Extremidades ", bold: true, fontSize: 10 },
                { text: data.fisico.extremidades, style: "textStyle" },
              ],
              [
                { text: "Neurológico ", bold: true, fontSize: 10 },
                { text: data.fisico.neurologico, style: "textStyle" },
              ],
              [
                { text: "Genitourinatio ", bold: true, fontSize: 10 },
                { text: data.fisico.genitourinario, style: "textStyle" },
              ],
              [
                {
                  text: "Piel y Faneras ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                },
                {
                  text: data.fisico.piel_faneras,
                  style: "textStyle",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const medicalPlanInformation = () => {
    try {
      if (data.plan != undefined) {
        return {
          margin: [0, 5, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Análisis y Plan Médico ",
                  style: "tableheader",
                  colSpan: 2,
                  border: [false, false, false, true],
                },
                "",
              ],
              [
                { text: "Análisis: ", bold: true, style: "textStyle" },
                { text: data.plan.analisis, style: "textStyle" },
              ],
              [
                { text: "Plan Médico: ", bold: true, style: "textStyle" },
                { text: data.plan.plan_medico, style: "textStyle" },
              ],
              [
                { text: "Recomendaciones: ", bold: true, style: "textStyle" },
                { text: data.plan.recomendaciones, style: "textStyle" },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const medicineRadiactive = () => {
    let tableBody = [];

	if (data.radioPharmacy !== undefined && data.radioPharmacy !== null) {
		if (data?.radioPharmacy.length > 0) {
		  tableBody.push([
			{
			  text: "Aplicación del radiofármaco",
			  colSpan: 4,
			  style: "tableheader",
			  border: [false, false, false, true],
			},
			"",
			"",
			"",
		  ]);

		  for (let j = 0; j < data.radioPharmacy.length; j++) {
			const element = data.radioPharmacy[j];

			tableBody.push([
			  {
				text: "Nombre del Medicamento: ",
				style: "textStyle",
				bold: true,
			  },
			  {
				text: element.nombre_medicamento,
				style: "textStyle",
			  },
			  {
				text: "Fecha de Aplicación: ",
				style: "textStyle",
				bold: true,
			  },
			  {
				text: moment(element.fecha_aplicacion).format("DD-MM-YYYY H:mm a"),
				style: "textStyle",
			  },
			]);

			tableBody.push([
			  {
				text: "Dosis y unidad de medida: ",
				style: "textStyle",
				bold: true,
			  },
			  {
				text: element.dosis,
				style: "textStyle",
			  },
			  {
				text: "Observación: ",
				style: "textStyle",
				bold: true,
			  },
			  {
				text: element.observacion,
				style: "textStyle",
			  },
			]);

			tableBody.push(["", "", "", ""]);
			tableBody.push([{}, {}, {}, {}]);
		  }
		} else {
		  console.log("no tiene tamaño");
		  return null;
		}
	}

    return {
      unbreakable: true,
      margin: [0, 10, 0, 10],
      layout: "headerLineOnly",
      table: {
        headerRows: 1,
        widths: ["auto", "*", "auto", "*"],
        body: tableBody,
      },
    };
  };

  const medicalRegister = (opt) => {
    try {
      if (data.medicalRegister != null && data.medicalRegister != undefined) {
        let entrevista_paciente = {
          alergias: data.medicalRegister.entrevista.alergias == true ? "X" : "",
          asma: data.medicalRegister.entrevista.asma == true ? "X" : "",
          marca_paso:
            data.medicalRegister.entrevista.marca_paso == true ? "X" : "",
          implante: data.medicalRegister.entrevista.implante == true ? "X" : "",
          protesis: data.medicalRegister.entrevista.protesis == true ? "X" : "",
          bomba_infusion:
            data.medicalRegister.entrevista.bomba_infusion == true ? "X" : "",
          operado: data.medicalRegister.entrevista.operado == true ? "X" : "",
          embarazo: data.medicalRegister.entrevista.embarazo == true ? "X" : "",
          puentes_dentales:
            data.medicalRegister.entrevista.puentes_dentales == true ? "X" : "",
          objetos_metalicos:
            data.medicalRegister.entrevista.objetos_metalicos == true
              ? "X"
              : "",
        };

        switch (opt) {
          case 1:
            return {
              unbreakable: true,
              margin: [0, 10, 0, 10],
              layout: "headerLineOnly",
              table: {
                headerRows: 1,
                widths: ["*", "*", "*", "*"],
                body: [
                  [
                    {
                      text: "Impresión Diagnóstica",
                      colSpan: 2,
                      style: "tableheader",
                    },
                    "",
                    "",
                    "",
                  ],
                  [{ text: "", style: "textStyle", bold: true }, "", "", ""],
                ],
              },
            };
            break;
          case 2:
            return {
              unbreakable: true,
              layout: "headerLineOnly",
              margin: [0, 0, 0, 10],
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: data.medicalRegister.impresion_diagnostica,
                      style: "textStyle",
                    },
                  ],
                  [
                    {
                      text: data.medicalRegister.observaciones,
                      style: "textStyle",
                    },
                  ],
                ],
              },
            };
            break;
          case 3:
            return {
              unbreakable: true,
              margin: [0, 10, 0, 10],
              layout: "headerLineOnly",
              table: {
                headerRows: 1,

                widths: ["*", "*", "*", "*"],
                body: [
                  [
                    {
                      text: "Antecedentes",
                      colSpan: 2,
                      style: "tableheader",
                    },
                    "",
                    "",
                    "",
                  ],
                  [{ text: "", style: "textStyle", bold: true }, "", "", ""],
                ],
              },
            };
            break;
          case 4:
            return {
              margin: [0, 0, 0, 10],
              text: data.medicalRegister?.entrevista?.otros_sintomas_text,
              style: "textStyle",
            };
            break;
          case 5:
            return {
              margin: [0, 5],
              columns: [
                {
                  width: "*",
                  text: "Alergias ( " + entrevista_paciente.alergias + " )",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text: "Asma  (  " + entrevista_paciente.asma + " )",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text:
                    "Marca Paso (  " + entrevista_paciente.marca_paso + " )",
                  style: "textStyle",
                },
              ],
            };
            break;
          case 6:
            return {
              margin: [0, 5],
              columns: [
                {
                  width: "*",
                  text: "Implante ( " + entrevista_paciente.implante + " )",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text: "Prótesis  ( " + entrevista_paciente.protesis + " )",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text:
                    "Bomba Infusión ( " +
                    entrevista_paciente.bomba_infusion +
                    " )",
                  style: "textStyle",
                },
              ],
            };
            break;
          case 7:
            return {
              margin: [0, 5],
              columns: [
                {
                  width: "*",
                  text: "Operado   ( " + entrevista_paciente.operado + " )",
                  style: "textStyle",
                },
                data.gender.toUpperCase() == "FEMENINO"
                  ? {
                      width: "*",
                      text:
                        "Embarazo  ( " + entrevista_paciente.embarazo + " )",
                      style: "textStyle",
                    }
                  : null,
                {
                  width: "*",
                  text:
                    "Puentes Dentales  ( " +
                    entrevista_paciente.puentes_dentales +
                    " )",
                  style: "textStyle",
                },
              ],
            };
            break;
          case 8:
            return {
              margin: [0, 5],
              columns: [
                {
                  width: "*",
                  text:
                    "Objetos Metálicos ( " +
                    entrevista_paciente.objetos_metalicos +
                    " )",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text: "",
                  style: "textStyle",
                },
                {
                  width: "*",
                  text: "",
                  style: "textStyle",
                },
              ],
            };
            break;
          case 9:
            return {
              margin: [0, 10, 0, 5],
              text:
                "Antecedentes Registro Clínico: \n " +
                data.medicalRegister?.entrevista?.otros_sintomas_text,
              style: "textStyle",
            };
            break;
          case 10:
            return diagnosticInformationFromInterview();
            break;
        }
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const proceduresInformations = (opt) => {
    switch (opt) {
      case 1:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return {
            text: "Procedimientos",
            style: "tableheader",
            layout: "lightHorizontalLines",
          };
        } else {
          return null;
        }
        break;
      case 2:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return {
            margin: [0, 5, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: ["*", "*"],
              headerRows: 1,
              body: [
                [{ text: "Audiometría ", style: "tableheader" }, ""],
                [{ text: "", style: "tableheader" }, ""],
              ],
            },
          };
        } else {
          return null;
        }
        break;
      case 3:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return htmlSpeechTerapy;
        } else {
          return null;
        }
        break;
    }
  };

  const medicalOrdersInformation = (opt) => {
    try {
      switch (opt) {
        case 1:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              margin: [0, 5, 0, 10],
              table: {
                widths: ["*", "auto", "*", "*"],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "Formulación Exámenes/Consultas",
                      style: "tableheader",
                      colSpan: 4,
                      border: [false, false, false, true],
                    },
                    "",
                    "",
                    "",
                  ],
                ],
              },
            };
          } else {
            return null;
          }
          break;
        case 2:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              margin: [0, 10, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["*", "auto", "*", "*"],
                headerRows: 1,
                body: body,
              },
            };
          } else {
            return null;
          }
          break;
        case 3:
          if (data.ordenes != null && data.ordenes != undefined) {
            if (
              data.ordenes.ordenes.ordenes.observationAndProcedure != null &&
              data.ordenes.ordenes.ordenes.observationAndProcedure != ""
            ) {
              return {
                text: "Observaciones de Exámenes/Consultas",
                style: "tableheader",
                layout: "lightHorizontalLines",
              };
            }
          } else {
            return null;
          }
          break;
        case 4:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              text: data.ordenes.ordenes.ordenes.observationAndProcedure,
              style: "textStyle",
            };
          } else {
            return null;
          }
          break;
        case 5:
          if (
            data.ordenes != null &&
            data.ordenes != undefined &&
            data.ordenes.tratamiento.tratamiento.length
          ) {
            return {
              unbreakable: true,
              margin: [0, 5, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: [50, "*", "*", "*", "*", "*", "*", "*"],
                headerRows: 1,
                body: tableBodyMedicine,
              },
            };
          } else {
            return null;
          }
          break;
        case 6:
          if (data.ordenes != null && data.ordenes != undefined) {
            if (
              data.ordenes.ordenes.ordenes.medicalObservation != null &&
              data.ordenes.ordenes.ordenes.medicalObservation != ""
            ) {
              return {
                text: "Observaciones de Medicamentos",
                style: "tableheader",
                layout: "lightHorizontalLines",
              };
            }
          } else {
            return null;
          }
          break;
        case 7:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              text: data.ordenes.ordenes.ordenes.medicalObservation,
              style: "textStyle",
            };
          } else {
            return null;
          }
          break;
      }
    } catch (err) {
      return null;
    }
  };

  const diagnosticInformation = (opt) => {
    try {
      if (data.diagnostico !== undefined) {
        switch (opt) {
          case 1:
            return {
              unbreakable: true,
              margin: [0, 5, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["*", "auto", "*", "*"],
                headerRows: 1,
                body: bodyDiagnostic,
              },
            };
            break;
          case 2:
            if (data.diagnostico.hasOwnProperty("observaciones")) {
              if (!!data.diagnostico.observaciones) {
                return {
                  text: "Observación Diagnóstico",
                  style: "tableheader",
                  layout: "lightHorizontalLines",
                };
              } else {
                return null;
              }
            } else {
              return null;
            }
            break;
          case 3:
            if (data.diagnostico.hasOwnProperty("observaciones")) {
              if (!!data.diagnostico.observaciones) {
                return {
                  text: data.diagnostico.observaciones,
                  style: "textStyle",
                };
              } else {
                return null;
              }
            } else {
              return null;
            }
            break;

          default:
            break;
        }
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const diagnosticInformationFromInterview = () => {
    try {
      if ((data.medicalRegister !== null, data.medicalRegister !== undefined)) {
        return {
          unbreakable: true,
          margin: [0, 5, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["auto", "*", "*"],
            headerRows: 1,
            body: bodyDiagnosticFromInterview,
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const clinicNotes = () => {
    try {
      if (
        data.notas_clinicas !== undefined &&
        typeof data.notas_clinicas !== "[]"
      ) {
        return {
          margin: [0, 5, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["auto", "auto", "auto", "auto"],
            headerRows: 1,
            body: bodyClinicNotes,
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const transcriptionResults = () => {
    try {
      if (data.transcripcion !== null && data.transcripcion !== undefined) {
        return {
          margin: [0, 5, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["*", "auto"],
            headerRows: 1,
            body: bodyTranscription,
          },
        };
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const otherProceduresResults = () => {
    try {
      if (data.otherProcedures !== null && data.otherProcedures !== undefined) {
        return {
          margin: [0, 10, 0, 5],
          layout: "headerLineOnly",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: tableBodyOtherProcedures,
          },
        };
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const IncapacityInfo = () => {
    try {
      if (
        data.infoIncapacityCurrentAdmision !== null &&
        data.infoIncapacityCurrentAdmision !== undefined
      ) {
        return {
          margin: [0, 10, 0, 5],
          layout: {
            defaultBorder: false,
          },
          style: "tableText",
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Incapacidad ",
                  style: "tableheader",
                  bold: true,
                  alignment: "rigth",
                  border: [false, false, false, true],
                  colSpan: 4,
                },
                "",
                "",
                "",
              ],
              [
                {
                  text: "Días de incapacidad: ",
                  style: "textStyle",
                  bold: true,
                  alignment: "rigth",
                },
                {
                  text: data.infoIncapacityCurrentAdmision[0]?.dias_incapacidad,
                  style: "textStyle",
                  alignment: "rigth",
                },
                {
                  text:
                    "Fecha de inicio: " +
                    moment(
                      data.infoIncapacityCurrentAdmision[0]?.fecha_incial
                    ).format("DD-MM-YYYY"),
                  style: "textStyle",
                  bold: true,
                  alignment: "left",
                },
                {
                  text:
                    "Fecha en la que termina: " +
                    moment(
                      data.infoIncapacityCurrentAdmision[0]?.fecha_final
                    ).format("DD-MM-YYYY"),
                  style: "textStyle",
                  bold: true,
                  alignment: "left",
                },
              ],
              [
                {
                  text: "Observaciones: ",
                  style: "textStyle",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: data.infoIncapacityCurrentAdmision[0]?.observaciones,
                  style: "textStyle",
                  colSpan: 3,
                  border: [false, false, false, true],
                },
                "",
                "",
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dataLegalRepresent = () => {
    const legalRepresententes = [];

    let hasInformation = false;

    let currentAdmission = data.infoAdmission.admision.representante_legal;

    hasInformation = Object.values(
      currentAdmission.representante_legal[0]
    ).some((val) => val != "");

    legalRepresententes.push([
      {
        text: "Datos del Representente Legal",
        style: "tableheader",
        border: [false, false, false, true],
        colSpan: 4,
      },
      "",
      "",
      "",
    ]);

    hasInformation === false
      ? legalRepresententes.push([
          {
            text: "No suministra información",
            style: "textRepresentandCompanion",
            colSpan: 4,
          },
          "",
          "",
          "",
        ])
      : null;

    if (hasInformation) {
      for (let k = 0; k < currentAdmission.representante_legal.length; k++) {
        const currentLegalReprensent = currentAdmission.representante_legal[k];

        if (currentLegalReprensent) {
          legalRepresententes.push([
            {
              text: "Nombre:  ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.nombre_completo,
              style: "textStyle",
            },
            {
              text: "Identificación: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.num_documento,
              style: "textStyle",
            },
          ]);
          legalRepresententes.push([
            {
              text: "Teléfonos: ",
              bold: true,
              style: "textStyle",
            },
            {
              text:
                currentLegalReprensent.telefono1 +
                " / " +
                currentLegalReprensent.telefono2,
              style: "textStyle",
            },
            {
              text: "Parentesco: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.parentesco,
              style: "textStyle",
            },
          ]);
          legalRepresententes.push([{}, {}, {}, {}]);
        }
      }
    }
    return legalRepresententes;
  };

  const dataCompanion = () => {
    const companions = [];

    let currentAdmission = data.infoAdmission.admision;

    let hasInformation = currentAdmission.acompanante !== null;

    let hasCompanion =
      currentAdmission.acompanante.hasOwnProperty("acompañante") &&
      currentAdmission.acompanante.acompañante.length > 0;

    companions.push([
      {
        text: "Datos del Acompañante",
        style: "tableheader",
        border: [false, false, false, true],
        colSpan: 4,
      },
      "",
      "",
      "",
    ]);

    hasCompanion === false
      ? companions.push([
          {
            text: "Sin acompañante",
            style: "textRepresentandCompanion",
            colSpan: 4,
          },
          "",
          "",
          "",
        ])
      : null;

    if (hasInformation) {
      if (hasCompanion) {
        for (
          let k = 0;
          k < currentAdmission.acompanante.acompañante.length;
          k++
        ) {
          const currentCompanion = currentAdmission.acompanante.acompañante[k];

          if (currentCompanion) {
            companions.push([
              {
                text: "Nombre:  ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.nombre,
                style: "textStyle",
              },
              {
                text: "Identificación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.num_documento,
                style: "textStyle",
              },
            ]);
            companions.push([
              {
                text: "Teléfonos:",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.tel1 + " / " + currentCompanion.tel2,
                style: "textStyle",
              },
              {
                text: "Parentesco: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.parentesco,
                style: "textStyle",
              },
            ]);
            companions.push([{}, {}, {}, {}]);
          }
        }
      }
    }

    return companions;
  };

  const dataTiposDisability = () => {
    const tipos = data.disability.discapacidades.map((d) => {
      const subtipos = d.tipo.map((t) => t.nombre).join(", ");
      return {
        text: [{ text: `${d.nombre}: `, bold: true }, subtipos + "\n"],

        margin: [0, 2, 0, 0],
      };
    });

    return [
      {
        columns: [
          { text: "Tipo de discapacidad", bold: true, margin: [20, 0, 0, 0] },
        ],
        margin: [0, 10, 0, 2],
      },
      ...tipos,
    ];
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [20, 50, 20, 20],
    defaultStyle: {
      fontSize: 8,
      alignment: "left",
    },
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              { text: name, style: "head" },
              {
                text: "Fecha Impresión: " + fecha,
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 0, 5],
      };
    },
    content: [
      {
        // auto-sized columns have their widths based on their content
        unbreakable: true,
        margin: [0, 10, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["*", "auto", "*", "auto"],
          body: [
            [
              {
                text: "Datos del Paciente ",
                style: "tableheader",
                border: [false, false, false, true],
                colSpan: 2,
              },
              "",
              {
                text: "Admisión: " + data.infoAdmission.admision?.id_admision,
                style: "tableheader",
                border: [false, false, false, true],
              },
              {
                text:
                  "Fecha Atención: " +
                  moment(
                    `${fechaAdmision} ${data.infoAdmission.admision?.hora}`
                  ).format("DD-MM-YYYY HH:mm a"),
                style: "tableheader",
                border: [false, false, false, true],
              },
            ],
            [
              { text: "Nombre: ", bold: true, style: "textStyle" },
              { text: data.names, style: "textStyle" },
              { text: "Identificación: ", bold: true, style: "textStyle" },
              {
                text: data.typeOfDocument + "-" + data.documentNumber,
                style: "textStyle",
              },
            ],
            [
              { text: "Fecha Nacimiento:", bold: true, style: "textStyle" },
              {
                text: moment(data.birthday).format("DD-MM-YYYY"),
                style: "textStyle",
              },
              { text: "Edad: ", bold: true, style: "textStyle" },
              { text: calculateAgeParse(data.birthday), style: "textStyle" },
            ],
            [
              { text: "Género: ", bold: true, style: "textStyle" },
              { text: data.gender, style: "textStyle" },
              { text: "Tipo de Sangre: ", bold: true, style: "textStyle" },
              { text: data.bloodType, style: "textStyle" },
            ],
            [
              { text: "Dirección: ", bold: true, style: "textStyle" },
              { text: data.address, style: "textStyle" },
              { text: "Ciudad: ", bold: true, style: "textStyle" },
              { text: data.city, style: "textStyle" },
            ],
            [
              { text: "Estado Civil: ", bold: true, style: "textStyle" },
              { text: data.civilStatus, style: "textStyle" },
              { text: "Teléfonos: ", bold: true, style: "textStyle" },
              {
                text:
                  data.cellphone === null
                    ? data.telephone
                    : data.telephone + " / " + data.cellphone,
                style: "textStyle",
              },
            ],
            [
              { text: "Entidad: ", bold: true, style: "textStyle" },
              { text: data.thirdName, style: "textStyle" },
              { text: "Régimen: ", bold: true, style: "textStyle" },
              { text: data.regime, style: "textStyle" },
            ],
            [
              { text: "Ocupación: ", bold: true, style: "textStyle" },
              { text: data.occupation?.nombre ?? null, style: "textStyle" },
              {
                text: "Población vulnerable: ",
                bold: true,
                style: "textStyle",
              },
              { text: data.poblacionVulnerable, style: "textStyle" },
            ],
            [
              {
                text: "Discapacidad: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.disability?.discapacidad ?? null,
                style: "textStyle",
              },
              data.disability?.discapacidad === "Si"
                ? {
                    text: "Tipo de Discapacidad: ",
                    bold: true,
                    style: "textStyle",
                  }
                : null,
              data.disability?.discapacidad === "Si"
                ? {
                    text: dataTiposDisability(),
                    style: "textStyle",
                  }
                : null,
            ],
            ["", "", "", ""],
            ...dataLegalRepresent(),
            ...dataCompanion(),
          ],
        },
      },

      medicineRadiactive(),
      //medicalRegister(1), // titulo: Impresión Diagnóstica
      medicalRegister(10), //cie10 diagnóstico desde RC
      medicalRegister(2), // observaciones del cie10 diagnóstico
      medicalRegister(3), // titulo: Antecedentes
      //medicalRegister(4), // observaciones de Antecedentes
      medicalRegister(5), // Antecedentes del RC
      medicalRegister(6), // Antecedentes del RC
      medicalRegister(7), // Antecedentes del RC
      medicalRegister(8), // Antecedentes del RC
      medicalRegister(9), //observaciones de antecedentes del RC
      ananmnesisInformation(),
      backgroundInformation(),
      backgroundInformationHabits(),
      systemInformation(),
      physicalInformations(),
      physicalInformationBody(),
      diagnosticInformation(1), //Tabla de Diagnósticos
      diagnosticInformation(2), //Titulo Observaciones de diagnósticos
      diagnosticInformation(3), //Observaciones de diagnósticos
      medicalPlanInformation(), // Analisis y Plan Medico
      proceduresInformations(1),
      proceduresInformations(2),
      proceduresInformations(3),
      medicalOrdersInformation(),
      medicalOrdersInformation(1), // titulo Formulación Exámenes
      medicalOrdersInformation(2), // tablas  de ordenes y procedimientos medicos
      medicalOrdersInformation(3), // titulo Observaciones de Ordenes Medica
      medicalOrdersInformation(4), // texto de observaciones de oridenes medicas
      medicalOrdersInformation(5), // tabla de formulas
      medicalOrdersInformation(6), // titulo observaciones de formulas
      medicalOrdersInformation(7), // texto observaciones de formulas
      transcriptionResults(), //Si el resultado es una transcripcion la muestra
      otherProceduresResults(), // si hay resultados de otros prodecimientos los muestra
      data.notas_clinicas.length > 0 ? clinicNotes() : null,
      IncapacityInfo(),
      {
        columns: signatures,
      },
    ],
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 9,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 10, 0, 0],
        fontSize: 9,
        alignment: "left",
        font: "OpenSans",
        bold: true,
      },
      textRepresentandCompanion: {
        fontSize: 10,
      },
    },
  };

  //pdfMake.createPdf(documentDefinition).open();
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });
  function findInlineHeight(cell, maxWidth, usedWidth = 0) {
    function mapTableBodies(innerTableCell) {
      const inlineHeight = findInlineHeight(
        innerTableCell,
        maxWidth,
        usedWidth
      );

      usedWidth = inlineHeight.width;
      return inlineHeight.height;
    }
    let calcLines = (inlines) => {
      if (!inlines)
        return {
          height: 0,
          width: 0,
        };
      let currentMaxHeight = 0;
      let lastHadLineEnd = false;
      for (const currentNode of inlines) {
        usedWidth += currentNode.width;
        if (usedWidth > maxWidth || lastHadLineEnd) {
          currentMaxHeight += currentNode.height;
          usedWidth = currentNode.width;
        } else {
          currentMaxHeight = Math.max(currentNode.height, currentMaxHeight);
        }
        lastHadLineEnd = !!currentNode.lineEnd;
      }
      return {
        height: currentMaxHeight,
        width: usedWidth,
      };
    };
    if (cell._offsets) {
      usedWidth += cell._offsets.total;
    }
    if (cell._inlines && cell._inlines.length) {
      return calcLines(cell._inlines);
    } else if (cell.stack && cell.stack[0]) {
      return cell.stack
        .map((item) => {
          return findInlineHeight(item, maxWidth);
        })
        .reduce((prev, next) => {
          return {
            height: prev.height + next.height,
            width: Math.max(prev.width + next.width),
          };
        });
    } else if (cell.table) {
      let currentMaxHeight = 0;
      for (const currentTableBodies of cell.table.body) {
        const innerTableHeights = currentTableBodies.map(mapTableBodies);
        currentMaxHeight = Math.max(...innerTableHeights, currentMaxHeight);
      }
      return {
        height: currentMaxHeight,
        width: usedWidth,
      };
    } else if (cell._height) {
      usedWidth += cell._width;
      return {
        height: cell._height,
        width: usedWidth,
      };
    }

    return {
      height: null,
      width: usedWidth,
    };
  }

  function applyVerticalAlignment(node, rowIndex, align, manualHeight = 0) {
    // New default argument
    const allCellHeights = node.table.body[rowIndex].map(
      (innerNode, columnIndex) => {
        if (innerNode._span) return null;
        const calcWidth = [...Array(innerNode.colSpan || 1).keys()].reduce(
          (acc, i) => {
            return acc + node.table.widths[columnIndex + i]._calcWidth;
          },
          0
        );
        const mFindInlineHeight = findInlineHeight(
          innerNode,
          calcWidth,
          0,
          rowIndex,
          columnIndex
        );
        return mFindInlineHeight.height;
      }
    );
    const maxRowHeight = manualHeight
      ? manualHeight[rowIndex]
      : Math.max(...allCellHeights); // handle manual height
    node.table.body[rowIndex].forEach((cell, ci) => {
      if (allCellHeights[ci] && maxRowHeight > allCellHeights[ci]) {
        let topMargin;

        let cellAlign = align;
        if (Array.isArray(align)) {
          cellAlign = align[ci];
        }

        if (cellAlign === "bottom") {
          topMargin = maxRowHeight - allCellHeights[ci];
        } else if (cellAlign === "center") {
          topMargin = (maxRowHeight - allCellHeights[ci]) / 2;
        }

        if (topMargin) {
          if (cell._margin) {
            cell._margin[1] = topMargin;
          } else {
            cell._margin = [0, topMargin, 0, 0];
          }
        }
      }
    });
  }
};

export default eventoClinicoPDF;
